module.exports = __webpack_public_path__ + "dbe7fc2f587f1e7a30fa3f4c3afbe718.png";